import React from "react";
import { Grid } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TextField, SimpleShowLayout, SelectField, ArrayField, Datagrid } from "react-admin";
import { agreeStatus } from "../../../../utils/options";
import {
  raLabeledStyle,
  raSimpleShowLayoutFlexRow,
  raSimpleShowLayoutCellFlex,
  accordionTitle,
} from "../../../../customStyles/ra-custom-styles";

export const SubscriptionsExpand = () => {
  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <Typography sx={accordionTitle}>Данни за абонамента</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ArrayField
            label="Поръчани издания"
            source="editions"
          >
            <Datagrid
              bulkActionButtons={false}
              fullWidth
            >
              <TextField
                label="Наименование"
                source="edition_name"
              />
              <TextField
                label="Кат. №"
                source="catalog_number"
              />
              <TextField
                label="Период на абонамент"
                source="months_count"
              />
              <TextField
                label="Ед. цена"
                source="single_edition_price"
              />
              <TextField
                label="Кол."
                source="editions_quantity"
              />
            </Datagrid>
          </ArrayField>
          <SimpleShowLayout
            sx={{
              "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
              "& .RaLabeled-label": raLabeledStyle,
            }}
          >
            <TextField
              label="Обща цена"
              source="total_sum"
            />
          </SimpleShowLayout>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography sx={accordionTitle}>Данни за клиента</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12}
              md={4}
              lg={4}
            >
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
                  "& .RaLabeled-label": raLabeledStyle,
                }}
              >
                <TextField
                  label="Аб.камп."
                  source="campaign_name"
                />
                <TextField
                  label="E-мейл за доставка на ел изд."
                  source="receiver_email"
                />
                <TextField
                  label="Име на заявител"
                  source="giver_first_name"
                  sortable={true}
                />
                <TextField
                  label="Фамилия на заявител"
                  source="giver_last_name"
                  sortable={true}
                />
                <TextField
                  label="Населено място на заявител"
                  source="giver_city"
                />
                <TextField
                  label="Телефон на заявител"
                  source="giver_phone_number"
                />
              </SimpleShowLayout>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              lg={4}
            >
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
                  "& .RaLabeled-label": raLabeledStyle,
                }}
              >
                <TextField
                  label="Име на получател"
                  source="receiver_first_name"
                />
                <TextField
                  label="Фамилия на получател"
                  source="receiver_last_name"
                  sortable={true}
                />
                <TextField
                  label="Нас. място на получател"
                  source="receiver_city"
                />
                <TextField
                  label="ПК на получател"
                  source="receiver_postcode"
                />
              </SimpleShowLayout>
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              lg={4}
            >
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
                  "& .RaLabeled-label": raLabeledStyle,
                }}
              >
                <TextField
                  label="Област"
                  source="receiver_district"
                />
                <TextField
                  label="Община"
                  source="receiver_municipality"
                />
                <TextField
                  label="Населено място"
                  source="receiver_city"
                />
                <TextField
                  label="Квартал"
                  source="receiver_neighborhood"
                />
                <TextField
                  label="Улица"
                  source="receiver_street"
                />
                <TextField
                  label="Улица номер"
                  source="receiver_street_number"
                />
              </SimpleShowLayout>
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutCellFlex,
                  "& .RaLabeled-label": raLabeledStyle,
                  "& .RaSimpleShowLayout-stack": raSimpleShowLayoutFlexRow,
                }}
              >
                <TextField
                  label="Блок"
                  source="receiver_building"
                />
                <TextField
                  label="Вход"
                  source="receiver_entrance"
                />
                <TextField
                  label="Етаж"
                  source="receiver_floor"
                />
                <TextField
                  label="Ап."
                  source="receiver_apartment"
                />
              </SimpleShowLayout>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography sx={accordionTitle}>Данни за фактура</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
            >
              <SimpleShowLayout
                sx={{
                  "& .RaSimpleShowLayout-row": raSimpleShowLayoutFlexRow,
                  "& .RaLabeled-label": raLabeledStyle,
                }}
              >
                <SelectField
                  label="Желае фактура"
                  source="is_invoice_ordered"
                  choices={agreeStatus}
                  fullWidth
                  sx={{ marginTop: "0px", marginBottom: " 0px" }}
                />
                <SelectField
                  label="Издадена фактура"
                  source="is_invoice_given"
                  choices={agreeStatus}
                  fullWidth
                />
                <TextField
                  label="Фактура номер"
                  source="invoice_number"
                  fullWidth
                />
                <TextField
                  label="Булстат / ЕГН"
                  source="invoice_identification_number"
                  fullWidth
                />
                <TextField
                  label="ИНЗДДС"
                  source="invoice_tax_id"
                  fullWidth
                />
                <TextField
                  label="Фирма"
                  source="invoice_company_company"
                />
                <TextField
                  label="Адрес на фирма"
                  source="invoice_company_address"
                />
                <TextField
                  label="Допълнителен адрес за доставка"
                  source="invoice_billing_address"
                />
              </SimpleShowLayout>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </>
  );
};
